export default [
    {
        name: 'humanDate',
        function: (date) => {
            let d = new Date(date);
            return d.toLocaleString("pl-PL", { timeZone: "UTC" });
        }
    },
    {
        name: 'humanSize',
        function: (size) => {
            let i = Math.floor(Math.log(size) / Math.log(1024));
            return (
              (size / Math.pow(1024, i)).toFixed(2) * 1 +
              " " +
              ["B", "kB", "MB", "GB", "TB"][i]
            );
        }
    }
]